/**
 * @module src/utils/daoServiceUtils
 * @author lwc
 * @description 数据服务参数构造工具类.
 * @date 2021年9月10日
 * */

import { Message } from 'element-ui'

/**
 * 构造查询条件的方法
 * @desc 构造查询参数
 * @author lwc
 * @date 2021年9月10日
 * @model {Object} - 参数说明: 模型
 * @params {Object} - 参数说明: 构造的参数列表, searchColumns: 查询参数，orderColumns: 排序参数
 * [{
        propertyName: '字段名', String/Array 时间控件如果直接使用的type="daterange"，传String，如果使用了两个时间控件达到起止效果，则传数组,列如：['startEtd（开始时间的字段名）','endEtd（结束时间的字段名）']
        aliasName: '数据库中的字段名', // 若没该属性，默认取propertyName
        value: '值', String/Array, 时间控件如果直接使用的type="daterange"，传响应的v-model即可，如果使用了两个时间控件达到起止效果，则传数组,列如：['开始时间的值）','结束时间的值']
        operation: '操作符 EQ/LIKE',
        connector: '连接符 or/and等'
   }]
 * @extendProps {Object} - 参数说明: 返回值的扩展属性, 默认返回的对象包括page、limit、whereObj、valueObj四个属性
 * @example 调用示例
 */
function buildQueryParams(model, params, extendProps) {
    let _model = model, _searchData = params.searchColumns, _orderData = params.orderColumns, 
        _extendProps = extendProps, search = { valueObj: {}, ...params }, whereObj = null, valueObj = {};
    if(!model) {
        return  Message({
            message: '模型名称为定义',
            type: 'error',
            duration: 5 * 1000
        })
    }

    if(!Array.isArray(_searchData)) {
        return  Message({
            message: '请检查询参数是否为数组',
            type: 'error',
            duration: 5 * 1000
        })
    }

    // let getWhereObj = buildWhere(_model, _searchData)
    // console.log('OOOO',eval(getWhereObj))
    // let getValueObj = buildValue(_searchData)
    // console.log('OOOOHHHH',getValueObj)
    //在这里你看下能不能获取到联想控件 page 和 limit
    return {
        whereObj: eval(buildWhere(_model, _searchData)),
        valueObj:  buildValue(_searchData),
        page: 1,
        limit: 10,
        ..._extendProps
    }
} 

// 构建where条件
function buildWhere(_model, _searchData, whereObj = null) {
    _searchData.forEach((ele, index) => {
        let operation = ''
        if(ele.value && ele.value !== '') {
            if(!ele.aliasName) {
                ele.aliasName = ele.propertyName
            }
            // if(!ele.connector) {
            //     ele.connector = 'and'
            // }
            switch (ele.operation) {
                case 'NEQ':
                    operation = 'ne';
                    break;
                case 'LIKE':
                case 'LIKEIC':
                    operation = 'like';
                    break;
                case 'LIKES':
                case 'LIKEEIC':
                    operation = 'like';
                    break;
                case 'LIKEE':
                case 'LIKESIC':
                    operation = 'like';
                    break;
                case 'GT':
                    operation = 'gt';
                    break;
                case 'GE':
                    operation = 'goe';
                    break;
                case 'LT':
                    operation = 'lt';
                    break;
                case 'LE':
                    operation = 'loe';
                    break;
                case 'GTLT':
                case 'GELT':
                case 'GTLE':
                case 'GELE':
                case 'BETWEEN':
                    operation = 'between';
                    break;
                case 'IN':
                    operation = 'in';
                    break;
                case 'NIN':
                    operation = 'notIn';
                    break;
                case 'ISNOTNULL':
                    operation = 'notNull';
                    break;
                case 'ISN':
                    operation = 'isNull';
                    break;
                case 'EQ':
                default:
                    operation = 'eq';
                    break;
            }
            if(whereObj === null) {
                if(ele.connector && ele.connector === '' || ele.connector === undefined) {
                    // between的要特殊处理
                    if(operation === 'between') {
                        if(Array.isArray(ele.propertyName)) {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName[0] + "'," + "':" + ele.propertyName[1] + "')"
                            }
                        } else {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "Start'," + "':" + ele.propertyName + "End')"
                            }
                        }
                    }else {
                        whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "')"
                    }
                }else {
                    if(operation === 'between') {
                        if(Array.isArray(ele.propertyName)) {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName[0] + "'," + "':" + ele.propertyName[1] + "')." + ele.connector
                            }
                        } else {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "Start'," + "':" + ele.propertyName + "End')." + ele.connector
                            }
                        }
                    }else {
                        whereObj = '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "')." + ele.connector
                    }
                }
            }else {
                if(ele.connector && ele.connector === '' || ele.connector === undefined || index === _searchData.length - 1) {
                    if(operation === 'between') {
                        if(Array.isArray(ele.propertyName)) {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName[0] + "'," + "':" + ele.propertyName[1] + "'))"
                            }
                        } else {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "Start'," + "':" + ele.propertyName + "End'))"
                            }
                        }
                    }else {
                        whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "'))"
                    }
                }else {
                    if(operation === 'between') {
                        if(Array.isArray(ele.propertyName)) {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName[0] + "'," + "':" + ele.propertyName[1] + "'))." + ele.connector
                            }
                        } else {
                            if(ele.value[0] !== '' && ele.value[1] !== '') {
                                whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "Start'," + "':" + ele.propertyName + "End'))." + ele.connector
                            }
                        }
                    }else {
                        whereObj = whereObj + '(' + '_model' + '.' + ele.aliasName + '.' + operation + "(':" + ele.propertyName + "'))." + ele.connector
                    }
                }
            }
        }
    });

    return handleWherObj(whereObj)
}

// 构建value条件
function buildValue(_searchData, valueObj = {}) {
    console.log(_searchData)
    _searchData.forEach((ele, index) => {
        if(ele.value && ele.value !== '') {
            switch (ele.operation) {
                case 'LIKE':
                case 'LIKEIC':
                    valueObj[ele.propertyName] = '%' + ele.value + '%';
                    break;
                case 'LIKES':
                case 'LIKEEIC':
                    valueObj[ele.propertyName] = ele.value + '%';
                    break;
                case 'LIKEE':
                case 'LIKESIC':
                    valueObj[ele.propertyName] = '%' + ele.value;
                    break;
                case 'GTLT':
                case 'GELT':
                case 'GTLE':
                case 'GELE':
                case 'BETWEEN':
                    if(!Array.isArray(ele.propertyName)) {
                        if(ele.value[0] !== '' && ele.value[1] !== '') {
                            valueObj[ele.propertyName + 'Start'] = ele.value[0]
                            valueObj[ele.propertyName + 'End'] = ele.value[1]
                        }
                    } else {
                        if(ele.value[0] !== '') valueObj[ele.propertyName[0]] = ele.value[0]
                        if(ele.value[1] !== '') valueObj[ele.propertyName[1]] = ele.value[1]
                    }
                    break;
                case 'NEQ':
                case 'GT':
                case 'GE':
                case 'LT':
                case 'LE':
                case 'IN':
                case 'NIN':
                case 'ISNOTNULL':
                case 'ISN':
                case 'EQ':
                default:
                    valueObj[ele.propertyName] = ele.value;
                    break;
            }
        }
    })
    return valueObj
}

// 处理whereObj，末尾如果是.and/.or做去除处理
function handleWherObj(whereObj) {
    if(whereObj.match(/\)$/)) {
        return whereObj
    }else {
        if(whereObj.match(/\.and$/)) {
            whereObj = whereObj.substring( 0, whereObj.length - 4 )
            return whereObj
        }else if(whereObj.match(/\.or$/)) {
            whereObj = whereObj.substring( 0, whereObj.length - 4 )
            return whereObj
        }else {
            console.log('请检查条件是否有问题')
        }
    }
}


class daoServiceUtils {
    buildQueryParams = buildQueryParams
}

export default new daoServiceUtils();
